import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSecurity } from 'auth/hooks/useSecurity';
import { LoginPhase } from 'navigation/models/login-phase';
import {LOGIN_PATH} from '../../../user/routes';
import { EmailRequiredBlock } from './components/EmailRequiredBlock/EmailRequiredBlock';


export function SystemAccessPage() {
  const { loginPhase } = useSecurity();

  // Renderizar el bloqueo apropiado según la fase
  switch (loginPhase) {
    case LoginPhase.EMAIL_REQUIRED_BLOCKED:
      return <EmailRequiredBlock />;

    // Futuras expansiones ejemplos:
    // case LoginPhase.MAINTENANCE_MODE:
    //   return <MaintenanceBlock />;
    // case LoginPhase.TERMS_REQUIRED:
    //   return <TermsRequiredBlock />;

    default:
      // Fallback - redirigir al login
       return <Navigate to={LOGIN_PATH} replace />;
  }
}

